import React from 'react';
import styled from 'styled-components';

const StyledSpan = styled.span`
  padding-left: 0.5em;
  padding-right: 0.5em;
`;

export default () => <StyledSpan>·</StyledSpan>;
